/**
 * HTTP Status Codes
 */
export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500
} as const;

/**
 * Error Messages
 */
export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection.',
  UNAUTHORIZED: 'Unauthorized. Please login again.',
  FORBIDDEN: 'You do not have permission to perform this action.',
  NOT_FOUND: 'Resource not found.',
  SERVER_ERROR: 'Server error. Please try again later.',
  INVALID_EMAIL: 'Invalid email format.',
  PASSWORD_MISMATCH: 'Passwords do not match.',
  WEAK_PASSWORD: 'Password must contain at least 8 characters, uppercase, lowercase, and numbers.',
  USER_ALREADY_EXISTS: 'User already exists.'
} as const;

/**
 * Success Messages
 */
export const SUCCESS_MESSAGES = {
  LOGIN_SUCCESS: 'Login successful!',
  LOGOUT_SUCCESS: 'Logged out successfully.',
  REGISTRATION_SUCCESS: 'Registration successful! Please check your email to verify your account.',
  PASSWORD_RESET_SUCCESS: 'Password reset successful. Please check your email.'
} as const;

/**
 * Storage Keys
 */
export const STORAGE_KEYS = {
  TOKEN: 'yama_auth_token',
  REFRESH_TOKEN: 'yama_refresh_token',
  USER: 'yama_user',
  PREFERENCES: 'yama_preferences'
} as const;

/**
 * Routes
 */
export const ROUTES = {
  AUTH: '/auth',
  LOGIN: '/auth/login',
  REGISTER: '/auth/register',
  FORGOT_PASSWORD: '/auth/forgot-password',
  DASHBOARD: '/dashboard'
} as const;
